import * as tslib_1 from "tslib";
import { IMG_TAG_NAME, SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME } from './constants';
import handleSharePointLink from './handleSharePointLink';
import shouldProcessLink from './shouldProcessLink';
import trySetIdAndClassName from './trySetIdAndClassName';
import getSharingInformation from '../actions/getSharingInformation';
import { onSharePointLinkDetected } from '../actions/internalActions';
import datapoints from '../datapoints';
import isSharePointLink from '../utils/isSharePointLink';
import { logUsage } from 'owa-analytics';
export var AnchorElementsSource;
(function (AnchorElementsSource) {
    // User pastes html
    AnchorElementsSource[AnchorElementsSource["PasteHtml"] = 0] = "PasteHtml";
    // Loading from draft, forward, reply
    AnchorElementsSource[AnchorElementsSource["ContentChangedFromSetContent"] = 1] = "ContentChangedFromSetContent";
})(AnchorElementsSource || (AnchorElementsSource = {}));
export default function processAnchorElements(allLinks, hiddenReferenceAttachments, source, linkPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds, imageElementsCount) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var sharePointLinks, i, link, url, _a, eventName, customData, _b, eventName, customData, imageElementsInsideLinkCount, i, sharePointLink, response, _c, eventName, customData, _d, eventName, customData, _e, eventName, customData;
        return tslib_1.__generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    sharePointLinks = [];
                    for (i = 0; i < allLinks.length; i++) {
                        link = allLinks[i];
                        if (shouldProcessLink(link, hiddenReferenceAttachments)) {
                            url = getUrl(link);
                            if (!isSharePointLink(url)) {
                                continue;
                            }
                            trySetIdAndClassName(link);
                            if (processedLinkIds.indexOf(link.id) === -1) {
                                sharePointLinks.push({ id: link.id, url: link.href, anchorElement: link });
                                processedLinkIds.push(link.id);
                            }
                        }
                    }
                    if (sharePointLinks.length < 10) {
                        _a = datapoints.UnderTenSPLinksWhenProcessAnchorElements.datapoint, eventName = _a.name, customData = _a.customData;
                        logUsage(eventName, customData(source === AnchorElementsSource.PasteHtml, sharePointLinks.length));
                    }
                    else {
                        _b = datapoints.AtLeastTenSPLinksWhenProcessAnchorElements.datapoint, eventName = _b.name, customData = _b.customData;
                        logUsage(eventName, customData(source === AnchorElementsSource.PasteHtml));
                    }
                    imageElementsInsideLinkCount = 0;
                    i = 0;
                    _f.label = 1;
                case 1:
                    if (!(i < sharePointLinks.length)) return [3 /*break*/, 4];
                    sharePointLink = sharePointLinks[i];
                    if (isEligibleForBeautifyLink(sharePointLink.anchorElement) &&
                        source === AnchorElementsSource.PasteHtml) {
                        handleSharePointLink(linkPlugin, true, sharePointLink.anchorElement, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler);
                        return [3 /*break*/, 3];
                    }
                    imageElementsInsideLinkCount += sharePointLink.anchorElement.querySelectorAll(IMG_TAG_NAME)
                        .length;
                    return [4 /*yield*/, getSharingInformation(sharePointLink.url)];
                case 2:
                    response = _f.sent();
                    if (!linkPlugin.editor) {
                        _c = datapoints.ComposeEditorIsNullDuringProcessSPLinks.datapoint, eventName = _c.name, customData = _c.customData;
                        logUsage(eventName, customData(i, sharePointLinks.length));
                        return [2 /*return*/];
                    }
                    onSharePointLinkDetected(sharePointLink.id, viewState.sharingLinkIds, response, viewState, parentItemIdWrapper.itemId, infoBarAddHandler, infoBarRemoveHandler);
                    _f.label = 3;
                case 3:
                    i++;
                    return [3 /*break*/, 1];
                case 4:
                    if (imageElementsCount < 20) {
                        _d = datapoints.UnderTwentyImageElementsWhenProcessAnchorElements.datapoint, eventName = _d.name, customData = _d.customData;
                        logUsage(eventName, customData(source === AnchorElementsSource.PasteHtml, imageElementsCount, imageElementsCount - imageElementsInsideLinkCount));
                    }
                    else {
                        _e = datapoints.AtLeastTwentyImageElementsWhenProcessAnchorElements.datapoint, eventName = _e.name, customData = _e.customData;
                        logUsage(eventName, customData(source === AnchorElementsSource.PasteHtml));
                    }
                    return [2 /*return*/];
            }
        });
    });
}
function getUrl(link) {
    var url = link.getAttribute(SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME);
    if (url && url.length > 0) {
        return url;
    }
    return link.href;
}
export function isEligibleForBeautifyLink(link) {
    if (link.children.length > 0) {
        return false;
    }
    var url = link.getAttribute(SAFELINK_ORIGINALSRC_ATTRIBUTE_NAME);
    if (url) {
        return url === link.text;
    }
    else {
        return link.href === link.text;
    }
}
//# sourceMappingURL=processAnchorElements.js.map